import { render } from "./AppFooterComponent.vue?vue&type=template&id=664b1160&scoped=true&ts=true"
import script from "./AppFooterComponent.vue?vue&type=script&lang=ts"
export * from "./AppFooterComponent.vue?vue&type=script&lang=ts"

import "./AppFooterComponent.vue?vue&type=style&index=0&id=664b1160&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664b1160"]])

export default __exports__